<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <router-link tag="button" :to="{name: 'contract-status.create'}" class="btn btn-info">
                    <span class="btn-label">
                        <i class="material-icons">add</i>
                    </span>
                    Novo
                </router-link>
            </div>
        </div>
        <br />
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">list</i>
                        </div>
                        <h4 class="card-title ">Lista</h4>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th class="text-center">#</th>
                                        <th>Status</th>
                                        <th>Pagar 1ª parcela e encerrar formalização</th>
                                        <th>Deve transferir formalização?</th>
                                        <th>É uma pendência?</th>
                                        <th>Padrão ao fazer download</th>
                                        <th class="text-right">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr 
                                        v-show="items.length > 0"
                                        v-for="iterator in items" 
                                        :key="iterator.id">
                                        <td class="text-center">{{ iterator.id }}</td>
                                        <td>{{ iterator.status }}</td>
                                        <td>{{ iterator.finish_contract ? 'Sim' : 'Não' }}</td>
                                        <td>{{ iterator.must_transfer_formalization ? 'Sim' : 'Não' }}</td>
                                        <td>{{ iterator.is_pending ? 'Sim' : 'Não' }}</td>
                                        <td>{{ iterator.default_status_when_downloading_docs ? 'Sim' : 'Não' }}</td>
                                        <td class="td-actions text-right">
                                            <index-buttons
                                                :iterator=iterator
                                                :showAudit="false"
                                                :toAudit="{name: 'contract-status'}"
                                                :showEdit="true"
                                                :toEdit="{name: 'contract-status.edit', params: { id: iterator.id }}"
                                                :showRemove="true"
                                                dispatchRemove="contract_status/rem"
                                                :callbackRemove="getData"
                                                >
                                            </index-buttons>
                                        </td>
                                    </tr>
                                    <tr v-show="items.length==0">
                                        <td colspan="5">Nenhuma status de formalização encontrada!</td>
                                    </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    export default {
        computed: {
            items() {
                return this.$store.state.contract_status.itens;
            }
        },
        created: function () {
            this.getData();
        },
        data() {
            return {
                currentPage: 1
            };
        },
        methods: {
            remove: function (_item) {
                var self = this;
                this.$dialog.confirm('Deseja realmente remover o status de formalização"' + _item.status + '"?')
                        .then(function () {
                            self.$root.$emit('onLoading');

                            const response = self.$store.dispatch('contract_status/rem', _item);

                            response.then(function () {
                                self.$root.$emit('onLoading');
                                self.$notify.success("Status de formalização excluído com sucesso!");
                                self.getData();
                            });

                            response.catch(function () {
                                self.$root.$emit('onLoading');
                                self.$notify.danger("Não foi possível excluir o status de formalização!");
                            });
                        });
            },
            async getData() {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('contract_status/all');

                response.then(function () {
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            }
        }
    }
</script>